import { useState } from "react"

export const useGlobalStates = () => {

    // para formulario
    const [showSection, setShowSection] = useState('HOME')
    const [formOpeningMode, setFormOpeningMode] = useState('EDITABLE')
    
    // para la modal
    const [showModalDeposit, setShowModalDeposit ] = useState(false)
    const [modalOpeningMode, setModalOpeningMode] = useState('EDITABLE')

    //para el carusel de imagenes
    const [imagesCurrentIndex, setImagesCurrentIndex] = useState(0);



    return Object.freeze({
        formOpeningMode, setFormOpeningMode,
        showSection, setShowSection,
        showModalDeposit, setShowModalDeposit,
        modalOpeningMode, setModalOpeningMode,
        imagesCurrentIndex, setImagesCurrentIndex,
    })
}